import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

import openSourceGrid from '../../assets/open-source-grid.png';

const OpenSourceCard = () => {
  return (
    <Link href="/customers/oss-projects/" target="_blank" className="group">
      <aside className="relative flex h-96 flex-col justify-end overflow-hidden rounded-2xl bg-gray-1 text-white md:h-[25rem] md:flex-row  md:justify-normal">
        <div className="bg-fill absolute right-0 z-[1] h-full w-full bg-[radial-gradient(circle_at_center_16%,_transparent_24%,_#0B0D0F_50%)] md:w-[59%]  md:bg-[radial-gradient(circle_at_center_43%,_transparent_36%,_#0B0D0F_60%)]"></div>
        <Image
          alt="open-source icons in a grid"
          src={openSourceGrid}
          className="top-0 z-0 mx-auto h-[16rem] w-[31rem] items-center pr-3 pt-3 md:absolute md:right-3 md:h-full md:w-[36rem] lg:right-14 lg:h-[26rem] lg:w-[59%]"
        />
        <div className="z-[1] flex basis-1/2 flex-col justify-end gap-4 bg-gray-1 px-6 pb-10 pt-6 md:basis-5/12 md:justify-center md:px-10 md:pr-7 md:pt-10 lg:justify-start">
          <h3 className="text-h5">Open Source Projects</h3>
          <p className="text-body text-gray-5">
            Gradle is proud to support key open source projects with free instances of Develocity.
          </p>
          <p className="text-body underline-text-transition-blue mt-4 w-fit">Explore</p>
        </div>
      </aside>
    </Link>
  );
};

export default OpenSourceCard;
